export default {
  // general
  support_risks: 'Risks',
  'support_risks.singular': 'Risk',

  // list
  'support_risks.list.description': 'Detected Risks content manager',
  'support_risks.list.empty_text': 'No Risks Found',
  'support_risks.list.create_new_text': '+ New Risk',
  'support_risks.list.header.doc': 'Document',

  // delete
  'support_risks.list.delete.success': 'Successfully deleted Risk {{name}}',
  'support_risks.list.delete.error':
    'There was a problem while removing the Risk. Please try again.',

  // delete modal
  'support_risks.list.delete.modal.title': 'Delete Risk?',
  'support_risks.list.delete.modal.text':
    'Are you sure you want to delete Risk "{{name}}"? This action can\'t be undone.',

  // disable/enable
  'support_risks.disable': 'Disable',
  'support_risks.disabled': 'Disabled',
  'support_risks.enable': 'Enable',
  'support_risks.enabled': 'Enabled',

  // disable/enable modal
  'support_risks.list.disable.modal.text':
    'Are you sure you want to disable "{{name}}"? (It will not be deleted)',
  'support_risks.list.disable.modal.title': 'Disable Risk?',
  'support_risks.list.enable.modal.title': 'Enable Risk?',

  // create
  'support_risks.new.page_title': 'Add New Risk',
  'support_risks.new.create.success': 'Risk created successfully',
  'support_risks.new.create.error': 'Failed to create Risk',

  // form fields
  'support_risks.create_edit.field.name.label': 'Name of Risk',
  'support_risks.create_edit.field.doc.label': 'Document (Markdown)',
  'support_risks.create_edit.field.doc.placeholder': '## Risk: {Risk Name}',
  'support_risks.create_edit.field.query_type.label': 'Query Type',
  'support_risks.create_edit.field.query_type.helper_text':
    "Query Type can't be edited after risk creation.",
  'support_risks.create_edit.field.eval_exp.label': 'Evaluation Expression',
  'support_risks.create_edit.field.map_exp.label': 'Mapping Expression',
  'support_risks.create_edit.markdown_preview': 'Markdown Preview',

  // update
  'support_risks.edit.page_title': 'Edit Risk: {{riskName}}',
  'support_risks.edit.update.success': 'Risk updated successfully',
  'support_risks.edit.update.error': 'Failed to update Risk',

  // risk evaluation
  'support_risks.risk_evaluation.title': 'Risk Evaluation',
  'support_risks.risk_evaluation.button_text': 'Evaluate Risk',
  'support_risks.risk_evaluation.form.service_id.label':
    'Service ID (optional)',
  'support_risks.risk_evaluation.form.team_id.label': 'Team ID (optional)',

  // general
  'support_risks.successfully': 'Successfully',

  // general errors
  'support_risks.errors.loading_error': 'Error loading Risks',
  'support_risks.errors.page_loading_error':
    'We encountered an error on this page. Please try again later.',
  'support_risks.errors.failed_action':
    'A problem occurred while taking action',
  'support_risks.errors.try_again': 'Please try again.'
}
